import { useMediaQuery } from '@mui/material'
import theme from 'assets/theme'

export const useBreakpoints = (): {
  isMobile: boolean
  isMedium: boolean
  isTablet: boolean
  isDesktop: boolean
  isLarge: boolean
} => {
  return {
    // const mobileView //
    isMobile: useMediaQuery(theme.breakpoints.down('sm')),
    // const mediumView //
    isMedium: useMediaQuery(theme.breakpoints.down('md')),
    // const tabletView //
    isTablet: useMediaQuery(theme.breakpoints.down('lg')),
    // const desktopView //
    isDesktop: useMediaQuery(theme.breakpoints.up('md')),
    // const largeView //
    isLarge: useMediaQuery(theme.breakpoints.up('md')),
  }
}